<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <router-view />
    </a-config-provider>
    <app-loader v-if="loading && !isFullScreen"></app-loader>
  </div>
</template>

<script>
// 全局配置中文组件
import zhCN from "ant-design-vue/es/locale/zh_CN"
import { mapGetters } from "vuex"
import AppLoader from "@/components/AppLoader"
import {
  scheduleTableFixedAlign,
  syncAntTableFixedRowHeights
} from "@/utils/sync-table-fixed-rows"

export default {
  components: { AppLoader },
  data() {
    return {
      locale: zhCN,
      loading: true,
      isFullScreen: false
    }
  },
  computed: {
    ...mapGetters(["navigationmode", "loadMenus"])
  },
  watch: {
    $route: {
      handler(newVal) {
        if (
          newVal.path === "/login" ||
          newVal.path === "/reset" ||
          newVal.path === "/nopass"
        ) {
          this.isFullScreen = true
        } else {
          this.isFullScreen = false
        }
        // 路由切换后补齐固定列行高（覆盖非 CRUD / 弹层表格）
        this.$nextTick(() => {
          scheduleTableFixedAlign(document)
        })
      },
      immediate: true,
      deep: true
    },
    loadMenus(newVal) {
      if (newVal) {
        this.loading = false
        this.$nextTick(() => scheduleTableFixedAlign(document))
      }
    }
  },
  mounted() {
    // 窗口尺寸变化：纯 DOM 对齐（全站 Mutation/ResizeObserver 在 main.js 已安装）
    this._onWinResize = () => {
      if (this._resizeTimer) clearTimeout(this._resizeTimer)
      this._resizeTimer = setTimeout(() => {
        syncAntTableFixedRowHeights(document)
      }, 150)
    }
    window.addEventListener("resize", this._onWinResize)
  },
  beforeDestroy() {
    if (this._resizeTimer) clearTimeout(this._resizeTimer)
    if (this._onWinResize) {
      window.removeEventListener("resize", this._onWinResize)
    }
  }
}
</script>
<style lang="scss">
#app {
  height: 100%;
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue",
    Arial, sans-serif;
  background: #f0f3f8;
}
</style>
